/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_overall = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overall GC skew`)
};

const es_gcskew_overall = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesgo GC general`)
};

const de_gcskew_overall = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamter GC-Skew`)
};

const nl_gcskew_overall = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale GC-skew`)
};

const fr_gcskew_overall = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biais GC global`)
};

const it_gcskew_overall = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skew GC complessivo`)
};

const pt_br2_gcskew_overall = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC skew geral`)
};

const pt_gcskew_overall = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assimetria GC global`)
};

const ja_gcskew_overall = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全体のGCスキュー`)
};

const zh_gcskew_overall = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`总体 GC 偏斜`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_overall = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_overall(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_overall", locale)
	if (locale === "en") return en_gcskew_overall(inputs)
	if (locale === "es") return es_gcskew_overall(inputs)
	if (locale === "de") return de_gcskew_overall(inputs)
	if (locale === "nl") return nl_gcskew_overall(inputs)
	if (locale === "fr") return fr_gcskew_overall(inputs)
	if (locale === "it") return it_gcskew_overall(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_overall(inputs)
	if (locale === "pt") return pt_gcskew_overall(inputs)
	if (locale === "ja") return ja_gcskew_overall(inputs)
	return zh_gcskew_overall(inputs)
};